import { render, staticRenderFns } from "./FlowEditor.vue?vue&type=template&id=487513fc&scoped=true&"
import script from "./FlowEditor.vue?vue&type=script&lang=js&"
export * from "./FlowEditor.vue?vue&type=script&lang=js&"
import style0 from "./FlowEditor.vue?vue&type=style&index=0&id=487513fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487513fc",
  null
  
)

export default component.exports